import Model, {
  attr,
  belongsTo,
  type AsyncBelongsTo,
} from '@warp-drive/legacy/model';
import type { Type } from '@warp-drive/core/types/symbols';
import type { FragmentArray } from 'ember-data-model-fragments/array/fragment';
import { fragment, fragmentArray } from 'ember-data-model-fragments/attributes';
import type { EnumValue } from '@linc-technologies/linced-common/enums/base-enum';
import type DataType from '@linc-technologies/linced-common/enums/data-type';
import type InputType from '@linc-technologies/linced-common/enums/input-type';
import type Value from '@linc-technologies/linced-common/models/dynamic-field/value';
import type ValueListItem from '@linc-technologies/linced-common/models/dynamic-field/value-list-item';
import type Heading from '@linc-technologies/linced-common/models/school-options/heading';

// Proto: schools.Option.
export default class Field extends Model {
  declare [Type]: 'school-options/field';

  @attr('string', { defaultValue: '' })
  declare key: string;

  @attr('string', { defaultValue: '' })
  declare label: string;

  @attr('string', { defaultValue: '' })
  declare description: string;

  @belongsTo('school-options/heading', { async: true, inverse: null })
  declare headingId: AsyncBelongsTo<Heading>;

  @attr('number', { defaultValue: 0 })
  declare inputType: EnumValue<typeof InputType> | 0;

  @attr('number', { defaultValue: 0 })
  declare dataType: EnumValue<typeof DataType> | 0;

  @fragment('dynamic-field/value')
  declare default: Value | null;

  @attr('string', { defaultValue: '' })
  declare placeholder: string;

  @fragmentArray('dynamic-field/value-list-item')
  declare options: FragmentArray<ValueListItem>;

  @attr({ defaultValue: () => ({}) })
  declare htmlAttributes: Record<string, string>;

  @attr('number', { defaultValue: 0 })
  declare sequence: number;

  @attr()
  declare optionSetIds: unknown; // Actually a hasMany relationship to sets, but those only exist in the admin app.

  @attr('string', { defaultValue: '' })
  declare staticContent: string;
}
